import { Component, Input } from '@angular/core';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ContactoDetalle } from 'app/infrastructure/model/classes/contacto.class';

@Component({
    selector: 'add-contacto',
    templateUrl: './contactos.add.component.html'
})
export class AddContacto {
    @Input() contacto: ContactoDetalle = new ContactoDetalle()
    constructor(private modal: NgbModal, private activeModal: NgbActiveModal) {
        this.contacto.Imagen = 'assets/img/contacts/default.png';
    }

    onSubmit() {
        
    }
    eliminar() {
        
    }
    dismiss() {
        this.activeModal.dismiss();
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/channel/contactos.add.component.ts